// Settings are split into groups (Gameplay, Video and sound, ...): one shows at a time, picked from
// the list at the side. The last group is remembered in this browser.

const KEY = 'bhop-web-settings-group';

export class SettingsNav {
  private readonly buttons = [...document.querySelectorAll<HTMLButtonElement>('#setNav [data-group]')];
  private readonly groups = [...document.querySelectorAll<HTMLElement>('.setGroup[data-group]')];

  constructor() {
    for (const b of this.buttons) b.addEventListener('click', () => this.show(b.dataset.group!));
    let saved: string | null = null;
    try {
      saved = localStorage.getItem(KEY);
    } catch {
      // Storage blocked.
    }
    this.show(this.groups.some((g) => g.dataset.group === saved) ? saved! : this.groups[0].dataset.group!);
  }

  show(group: string) {
    for (const b of this.buttons) {
      const on = b.dataset.group === group;
      b.classList.toggle('on', on);
      b.setAttribute('aria-current', on ? 'true' : 'false');
    }
    for (const g of this.groups) g.hidden = g.dataset.group !== group;
    try {
      localStorage.setItem(KEY, group);
    } catch {
      // Not remembered.
    }
  }
}
